import React, { ReactElement } from 'react';
import { CUSTOM_TOP_DATA } from 'modules/shared/layout/menu/components/custom-top/custom-top.data';

import './custom-top.mobile.scss';

const CustomTopMobile: React.FC = (): ReactElement | null => {
    return (
        <div className="custom-top-mobile" data-section="top-bar">
            <div className="custom-top-mobile__header">
                Popularne
            </div>
            {CUSTOM_TOP_DATA.map(item => (
                <a
                    key={item.url}
                    className="custom-top-mobile__item"
                    href={item.url}
                    title={item.title}
                    target={item.target}
                    rel={item.rel ?? void 0}
                >
                    {item.title}
                </a>
            ))}
        </div>
    );
};

export default CustomTopMobile;
